<script>
  import { onMount } from "svelte";
  import { filterToString, ignore } from "../../../Common/tools";
  import Filter from "../../../Filter/Filter.svelte";
  import {M} from "../../../external";

  export let data;
  export let valid;
  export let onChange = ignore;

  if (!data) {
    data = {};
  }

  if (!data.subflowA) {
    data.subflowA = [];
  }

  if (!data.subflowB) {
    data.subflowB = [];
  }

  let filters = [];
  let filterInstance;

  if (data && data.settings) {
    filters = parseFilters(data.settings);
  }

  valid = filters[0]?.length > 0;

  function parseFilters(settings) {
    let filters = [];

    if (isOldVersion(settings)) {
      filters[0] = [];
      settings.forEach((setting) => {
        filters[0].push(JSON.parse(setting.value));
      });
      filters[0].key = 0;
    } else {
      settings.forEach((setting) => {
        let andFilters = JSON.parse(setting.value);
        andFilters.key = parseInt(setting.key);
        filters.push(andFilters);
      });
    }

    return filters;
  }

  function isOldVersion(settings) {
    return settings.some(element => !Array.isArray(JSON.parse(element.value))); //new version - all elements are arrays
  }

  function onFilterChange(notify) {
    if (filters) {
      data.settings = [];
      let counter = 0;

      filters.forEach((andFilters) => {
        andFilters.key = counter++;
        data.settings.push({
          key: String(andFilters.key),
          value: JSON.stringify(andFilters)
        });
      });

      data.name = filters
        .map((andFilters) => andFilters.map((filter) => filterToString(filter)).join(", "))
        .join(" " + M.OR + " ");

      valid = filters[0]?.length > 0;
      if (notify !== false && valid) {
        onChange();
      }
    }
  }
  onFilterChange(false);

  onMount(function () {
    filterInstance.onFilterChanged();
  });
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.STEP_SPLIT}</h4>
  <div class="multiple-items-picker mt-25 mb-5">
    <div class="groups category-groups mb-15" style="max-width:1200px;">
      <Filter
        enableOR={true}
        enableSaveSegment={false}
        enableHide={false}
        bind:this={filterInstance}
        bind:filters
        onChange={onFilterChange}
      />
    </div>
  </div>
  <div class="col20 f-left gray-section product-select-wrapper mb-5 none">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">Applied to everyone</h4>
      <a class="text-link blue-text" data-role="changeTextStyles">Change</a>
    </div>
  </div>
</div>
